import { Injectable } from '@angular/core';

@Injectable()
export class AutoActStateService {
  /** 文字拡大モード */
  public static bigFontMode = false;
  /** ヘッダ部の非表示設定 */
  public static hideHeader = false;
  /** スキャン結果の表示時間(ミリ秒指定) */
  public static displayMillisecOnScanResult = 2000;

  constructor() { }

  public resetAllParams(): void {

  }
}
